import classNames from 'classnames';
import useResizeLayout from '@Hooks/useResizeLayout';
import { Space } from 'antd';
import { TabSelectBtn } from './TabSelectBtn';
import { AssetsProfileTab } from '../Tab.enum';

import styles from './tab-switch.module.css';

interface TabSwitchProps {
  tab: AssetsProfileTab;
  changeTab: (tab: AssetsProfileTab) => void;
}

const TabSwitch: React.FC<TabSwitchProps> = ({ changeTab, tab }) => {
  const { isMobile } = useResizeLayout();

  return (
    <Space
      className={classNames(
        'trojan-neumorphism-box trojan-neumorphism-box-shadow',
        isMobile ? styles.tabSelectBoxMobile : styles.tabSelectBox
      )}
    >
      <TabSelectBtn
        className={styles.buttonTab}
        active={tab === AssetsProfileTab.ASSETS}
        value={AssetsProfileTab.ASSETS}
        onClick={() => changeTab(AssetsProfileTab.ASSETS)}
      >
        {AssetsProfileTab.ASSETS}
      </TabSelectBtn>
      <TabSelectBtn
        className={styles.buttonTab}
        value={AssetsProfileTab.SOFTWARE}
        active={tab === AssetsProfileTab.SOFTWARE}
        onClick={() => changeTab(AssetsProfileTab.SOFTWARE)}
      >
        {AssetsProfileTab.SOFTWARE}
      </TabSelectBtn>
    </Space>
  );
};

export default TabSwitch;
